<template>
  <footer>
    <!-- <h6>Pagamento via:</h6>
    <img src="@/assets/images/logo-getnet.jpg"> -->
  </footer>
</template>

<script>
// import mercadoPago from '@/assets/images/logo-getnet.jpg'

export default {
  name: 'invoiceFooter',
  props: ['gateway'],
  computed: {
    // gatewayImage () {
    //   let gateway = this.gateway || 'mercado-pago'
    //   let image, image2x

    //   if (gateway === 'mercado-pago') {
    //     image = mercadoPago
    //     image2x = mercadoPago2x
    //   }

    //   return { image, image2x }
    // }
  }
}
</script>
